import React from "react";

import { SegmentMetric } from "utils/optimizer/ProjectOptimizer";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

const ModelLabels = (props) => {
  const {
    compliancePlot,
    showFeedback,
    mode,
    setupLabels,
    overallOnly,
    optimized,
    businessAssumptions,
    modelGroups,
    primaryBusinessConstraintType,
    isMonitor
  } = props;

  const renderLabel = (text, topMargin = 0, extraText) => {
    if (text) {
      return (
        <div
          className={styles.modelBarHolder}
          style={{
            marginTop: topMargin ? `${topMargin}px` : "0px",
            justifyContent: "left"
          }}
        >
          <div className={styles.modelLabel} style={{ display: "flex", alignItems: "center" }}>
            {text}
            {extraText ? (
              <span
                className={styles.optimizedText}
                style={{
                  marginLeft: "10px",
                  fontWeight: "bold",
                  fontSize: "10px",
                  color: "#FFFFFF"
                }}
              >
                {extraText}
              </span>
            ) : null}
          </div>
        </div>
      );
    }
    return <div className={styles.modelBarHolder}>{""}</div>;
  };

  const renderOverviewLabels = () => {
    let isEmpty;
    let isPercentage;
    if (optimized && optimized.setup) {
      const setup = optimized.setup;
      isEmpty = setup.showImpact === undefined && setup.showBusiness === undefined;
      isPercentage = setup.showImpact === undefined && setup.showBusiness === true;
    }

    const allDriversAdded =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter(
        (group) => group && group.setup && group.column !== "Overall" && !group.setup.showImpact
      ).length === 0;

    const effortLabel = setupLabels.costLabel;
    const impactDriversAdded = !(isPercentage === true || isEmpty === true);

    const hasCompliancePlot = Boolean(compliancePlot && compliancePlot.length);

    return (
      <React.Fragment>
        <div style={{ height: "42px" }}>{""}</div>
        <div className={styles.sContent}>
          <div className={styles.fullColumn}>
            {showFeedback && renderLabel("Feedback", 0)}
            {renderLabel(setupLabels.notPursuedTransactionLabel, 5)}
            {renderLabel(setupLabels.transactionLabel, 40)}
            {renderLabel(setupLabels.outcomeLabel, 40)}
            {renderLabel(
              effortLabel,
              overallOnly ? 30 : 28,
              primaryBusinessConstraintType === SegmentMetric.Cost ? "Optimized" : undefined
            )}
            {renderLabel(
              setupLabels.revenueLabel,
              overallOnly ? 23 : 20,
              primaryBusinessConstraintType === SegmentMetric.Revenue ? "Optimized" : undefined
            )}
            {overallOnly &&
              impactDriversAdded &&
              renderLabel(
                setupLabels.profitLabel,
                25,
                primaryBusinessConstraintType === SegmentMetric.Profit ? "Optimized" : undefined
              )}
            {!businessAssumptions &&
              !overallOnly &&
              renderLabel(
                setupLabels.profitLabel,
                20,
                primaryBusinessConstraintType === SegmentMetric.Profit ? "Optimized" : undefined
              )}
            {isMonitor && hasCompliancePlot && renderLabel(setupLabels.trueAction + " Recommendations Followed", 20)}
            {isMonitor && hasCompliancePlot && renderLabel(setupLabels.falseAction + " Recommendations Followed", 25)}
          </div>
        </div>
      </React.Fragment>
    );
  };

  const renderModelLabels = () => {
    return (
      <React.Fragment>
        <div style={{ height: "42px" }}>{""}</div>
        <div className={styles.sContent}>
          <div className={styles.fullColumn}>
            {renderLabel("Impact", 20)}
            {renderLabel("Awards", 25)}
            {renderLabel("Model Type", 15)}
            {renderLabel("Focus", 15)}
            {renderLabel("Strengths", 35)}
          </div>
        </div>
      </React.Fragment>
    );
  };

  return (
    <div
      className={styles.smallModelBoxConsumer}
      style={{
        borderStyle: "none",
        boxShadow: "none",
        marginRight: overallOnly ? "0px" : "10px",
        marginLeft: overallOnly ? "20px" : "10px",
        width: overallOnly ? "200px" : "200px",
        cursor: "auto",
        minHeight: 450
      }}
    >
      {mode === "OVERVIEW" || !mode ? renderOverviewLabels() : mode === "MODEL" ? renderModelLabels() : null}
    </div>
  );
};

export default ModelLabels;
